export default __webpack_public_path__ + "static/media/Footwraps of the Reanimator.f28efbbe.jpg";